export const pteMinimumReportedScore = 10;
export const pteMaximumReportedScore = 90;
export const pteReportedScoreRange = pteMaximumReportedScore - pteMinimumReportedScore;

export function pteScoreFromTrait(
    traitScore: number,
    traitMin: number,
    traitMax: number,
): number | null {
    if (
        !Number.isFinite(traitScore) ||
        !Number.isFinite(traitMin) ||
        !Number.isFinite(traitMax) ||
        traitMax <= traitMin
    ) {
        return null;
    }

    const boundedTraitScore = Math.min(Math.max(traitScore, traitMin), traitMax);
    const normalized = (boundedTraitScore - traitMin) / (traitMax - traitMin);
    return Math.round(pteMinimumReportedScore + normalized * pteReportedScoreRange);
}
